import styled from "styled-components";

export const Container = styled.section`
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BodyWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const TitleWrapper = styled.div`
  text-align: center;
  margin: 0 auto 40px auto;
  & p {
    color: #212529;
    font-size: 18px;
  }
  word-break: keep-all;
`;

export const Sidebar = styled.div`
  width: 20%;
  word-break: keep-all;

  .sidebar-widget {
    padding: 20px;
  }

  .section-title {
    font-size: 1.3rem;
  }

  @media screen and (max-width: 350px) {
    width: 100%;
  }

  @media screen and (min-width: 351px) and (max-width: 991px) {
    width: 100%;
    & ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    & li {
      width: 45%;
    }
  }

  @media screen and (min-width: 991px) and (max-width: 1200px) {
    width: 30%;
  }

  @media screen and (max-width: 1200px) {
    .sidebar-widget {
      & h5 {
        font-size: 1.2rem;
      }
      & li {
        padding: 10px 0.5rem;
      }
    }
  }
`;

export const ContentsWrapper = styled.div`
  width: 80%;

  @media screen and (max-width: 350px) {
    width: 100%;
  }
  @media screen and (min-width: 351px) and (max-width: 991px) {
    width: 100%;
  }

  @media screen and (min-width: 991px) and (max-width: 1200px) {
    width: 70%;
  }
`;

export const SingleContentBox = styled.div`
  position: relative;
  background-color: #fff;
  border: 1px solid #ececec;
  border-radius: 15px;
  overflow: hidden;
  transition: 0.2s;
  -moz-transition: 0.2s;
  -webkit-transition: 0.2s;
  -o-transition: 0.2s;
  margin-bottom: 25px;
  :hover {
    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
    border: 1px solid #bce3c9;
    transition: 0.2s;
    -moz-transition: 0.2s;
    -webkit-transition: 0.2s;
    -o-transition: 0.2s;
  }
`;

export const SingleContentImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  max-height: 200px;
`;

export const SingleContentImg = styled.img`
  height: 180px;
  max-height: 200px;
`;

export const SingleContentTitle = styled.div`
  margin: 20px 0;
`;
